import React from 'react';

import { ApurataLoan } from '@/globalTypes/personalLoan.ts';
import { PosLoan } from '@/globalTypes/posLoan.ts';

type Lend = Partial<ApurataLoan & PosLoan>;

interface LendGlobalContextAttrs {
  lend: Lend | null;
  setLend: (lend: Lend) => void;
}

const LendGlobalContextDefaultValues: LendGlobalContextAttrs = {
  lend: null,
  setLend: () => {},
};

export const LendGlobalContext = React.createContext(LendGlobalContextDefaultValues);

export function LendGlobalContextProvider({ children }: { children: React.ReactNode }) {
  const [lend, setLend] = React.useState<Lend>(null);
  const memoizedContextValue = React.useMemo(
    () => ({
      lend,
      setLend,
    }),
    [lend]
  );

  return <LendGlobalContext.Provider value={memoizedContextValue}>{children}</LendGlobalContext.Provider>;
}
